/*
  Cheerful Buddha product gallery (Phase 1). Used by sections/cb-pdp-main.liquid.
  A scroll-snap track (swipe on touch, arrow keys when focused) with thumbnail buttons.
  Shows the selected variant's image on cb:variant-change ({ detail: { variant, sectionId } }).
  Vanilla JS, loaded with defer. Re-initialises on shopify:section:load.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function scrollBehaviour(smooth) {
    if (!smooth || (reduceMotion && reduceMotion.matches)) return 'auto';
    return 'smooth';
  }

  /* Start loading a lazy image before its slide scrolls into view. */
  function warm(slide) {
    if (!slide) return;
    var img = slide.querySelector('img[loading="lazy"]');
    if (img) img.setAttribute('loading', 'eager');
  }

  function initGallery(root) {
    if (!root || root.hasAttribute('data-cb-gallery-ready')) return;
    var track = root.querySelector('[data-cb-gallery-track]');
    if (!track) return;
    root.setAttribute('data-cb-gallery-ready', '');

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-cb-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cb-thumb]'));
    var strip = root.querySelector('[data-cb-gallery-thumbs]');
    var current = -1;
    var lockUntil = 0;
    var ticking = false;

    function indexFromScroll() {
      var width = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
    }

    function setActive(index, smooth) {
      if (index < 0 || index >= slides.length || index === current) return;
      current = index;
      /* The active photo's index on the gallery: the pack character (snippets/cb-pdp-char.liquid) shows only on
         the first photo, the pack shot, so it never sits on another photo's content (Design QA, 12 Oct 2026). */
      root.setAttribute('data-cb-active', String(index));
      thumbs.forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-current', on ? 'true' : 'false');
      });
      warm(slides[index]);
      warm(slides[index + 1]);
      warm(slides[index - 1]);

      /* Keep the active thumbnail visible in the mobile strip without moving the page. */
      var thumb = thumbs[index];
      if (thumb && strip && strip.scrollWidth > strip.clientWidth + 1) {
        var left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: scrollBehaviour(smooth) });
      }
    }

    function goTo(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      lockUntil = smooth ? Date.now() + 900 : 0;
      track.scrollTo({ left: slide.offsetLeft, behavior: scrollBehaviour(smooth) });
      setActive(index, smooth);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        goTo(index, true);
      });
      /* Keyboard: bring a focused thumbnail (and its focus ring) fully into the mobile strip.
         Browsers leave a half-visible element where it is when it takes focus. */
      thumb.addEventListener('focus', function () {
        if (!strip || strip.scrollWidth <= strip.clientWidth + 1) return;
        var left = thumb.offsetLeft - 8;
        var right = thumb.offsetLeft + thumb.offsetWidth + 8;
        if (left < strip.scrollLeft) {
          strip.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
        } else if (right > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: right - strip.clientWidth, behavior: 'auto' });
        }
      });
    });

    track.addEventListener(
      'scroll',
      function () {
        if (ticking || Date.now() < lockUntil) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          setActive(indexFromScroll(), true);
        });
      },
      { passive: true }
    );

    track.addEventListener('scrollend', function () {
      lockUntil = 0;
      setActive(indexFromScroll(), true);
    });

    /* Size changes jump without smooth scrolling: the buy box re-renders at the same moment and Firefox would
       snap a smooth scroll back to the old slide. Thumbnail clicks stay smooth. */
    document.addEventListener('cb:variant-change', function (event) {
      if (!root.isConnected) return;
      var detail = event.detail || {};
      if (detail.sectionId && detail.sectionId !== root.getAttribute('data-section-id')) return;
      var media = detail.variant && detail.variant.featured_media;
      var title = detail.variant && detail.variant.title ? String(detail.variant.title).trim().toLowerCase() : '';
      for (var i = 0; i < slides.length; i++) {
        var byMedia = media && slides[i].getAttribute('data-media-id') === String(media.id);
        /* Gallery image blocks can name a size ("Show for size"), e.g. the 1kg bag photo. */
        var byVariant = title && slides[i].getAttribute('data-variant') === title;
        if (byMedia || byVariant) {
          goTo(i, false);
          return;
        }
      }
      /* No slide for this size: leave another size's photo (e.g. 1kg -> 150g) for the first general slide. */
      var shown = slides[current] ? slides[current].getAttribute('data-variant') || '' : '';
      if (shown && shown !== title) {
        var back = 0;
        for (var j = 0; j < slides.length; j++) {
          if (!slides[j].getAttribute('data-variant')) {
            back = j;
            break;
          }
        }
        goTo(back, false);
      }
    });

    /* Theme editor: selecting a Gallery image block shows that slide. */
    document.addEventListener('shopify:block:select', function (event) {
      if (!root.isConnected) return;
      var index = slides.indexOf(event.target);
      if (index > -1) goTo(index, false);
    });

    var start = parseInt(root.getAttribute('data-cb-gallery-start'), 10) || 0;
    if (start > 0 && slides[start]) {
      goTo(start, false);
    } else {
      setActive(0, false);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cb-gallery]');
    Array.prototype.forEach.call(roots, initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
